import { render, staticRenderFns } from "./ReturnToStore.vue?vue&type=template&id=689ea608"
import script from "./ReturnToStore.vue?vue&type=script&lang=js"
export * from "./ReturnToStore.vue?vue&type=script&lang=js"
import style0 from "./ReturnToStore.vue?vue&type=style&index=0&id=689ea608&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports